import DateInput from "../../DateInput";

/**
 * Collapsible advanced-search panel used above the bookings table.
 * Pure controlled component: parent owns `advanced` state + apply/reset
 * callbacks.
 */
export default function AdvancedSearchPanel({
  advanced, setAdvanced, locations, onApply, onReset,
}) {
  return (
    <div
      className="bg-white dark:bg-[#1F2937] border border-black/10 dark:border-white/10 rounded p-5 mb-5"
      data-testid="advanced-search-form"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <AdvField label="Booking ID"           value={advanced.booking_id}         onChange={(v) => setAdvanced({ ...advanced, booking_id: v })}         testId="adv-booking-id" />
        <AdvField label="Customer name"        value={advanced.customer_name}      onChange={(v) => setAdvanced({ ...advanced, customer_name: v })}      testId="adv-customer" />
        <AdvField label="Vehicle (name or plate)" value={advanced.vehicle_plate}   onChange={(v) => setAdvanced({ ...advanced, vehicle_plate: v })}      testId="adv-vehicle" />
        <AdvSelect label="Pickup location"     value={advanced.pickup_location}    onChange={(v) => setAdvanced({ ...advanced, pickup_location: v })}    options={locations} testId="adv-pickup-loc" />
        <AdvSelect label="Return location"     value={advanced.return_location}    onChange={(v) => setAdvanced({ ...advanced, return_location: v })}    options={locations} testId="adv-return-loc" />
        <div className="hidden md:block" />
        <AdvField label="Pickup date from" type="date" value={advanced.pickup_date_from}  onChange={(v) => setAdvanced({ ...advanced, pickup_date_from: v })}  testId="adv-pickup-from" />
        <AdvField label="Pickup date to"   type="date" value={advanced.pickup_date_to}    onChange={(v) => setAdvanced({ ...advanced, pickup_date_to: v })}    testId="adv-pickup-to" />
        <div className="hidden md:block" />
        <AdvField label="Created from" type="date" value={advanced.date_created_from} onChange={(v) => setAdvanced({ ...advanced, date_created_from: v })} testId="adv-created-from" />
        <AdvField label="Created to"   type="date" value={advanced.date_created_to}   onChange={(v) => setAdvanced({ ...advanced, date_created_to: v })}   testId="adv-created-to" />
      </div>
      <div className="flex justify-end gap-2 mt-5">
        <button type="button" onClick={onReset} className="px-4 py-1.5 text-sm border border-black/15 dark:border-white/15 hover:border-black dark:hover:border-white transition-colors rounded" data-testid="adv-reset">Reset</button>
        <button type="button" onClick={onApply} className="bg-black text-white dark:bg-white dark:text-black px-4 py-1.5 text-sm hover:opacity-90 transition-opacity rounded" data-testid="adv-apply">Apply filters</button>
      </div>
    </div>
  );
}

function AdvField({ label, value, onChange, type = "text", testId }) {
  return (
    <label className="block">
      <span className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 dark:text-neutral-400 block mb-1">{label}</span>
      {type === "date" ? (
        <DateInput value={value} onChange={onChange} testId={testId} inputSize="sm" />
      ) : (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-transparent border-b border-black/15 dark:border-white/15 py-1.5 outline-none focus:border-black dark:focus:border-white text-sm"
          data-testid={testId}
        />
      )}
    </label>
  );
}

function AdvSelect({ label, value, onChange, options, testId }) {
  return (
    <label className="block">
      <span className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 dark:text-neutral-400 block mb-1">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-transparent border-b border-black/15 dark:border-white/15 py-1.5 outline-none focus:border-black dark:focus:border-white text-sm"
        data-testid={testId}
      >
        <option value="all">All locations</option>
        {options.map((o) => (
          <option key={o.id} value={o.name}>{o.name}</option>
        ))}
      </select>
    </label>
  );
}
